import styled from 'styled-components';
import { FormControlLabel, ToggleButtonGroup } from '@mui/material';

import colors from '../../../../../../styles/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  margin: 8px 0;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  padding: 12px;
  border: 1px solid ${colors.shades.gamma3};
  border-radius: 5px;
`;

const Label = styled.span`
  font-size: 12px;
  color: ${colors.shades.gamma10};
`;

const ToggleRow = styled(FormControlLabel)`
  && {
    display: flex;
    justify-content: space-between;
    margin: 0;
    width: 100%;
  }
`;

const StyledToggleButtonGroup = styled(ToggleButtonGroup)`
  flex-wrap: wrap;

  .MuiToggleButton-root {
    text-transform: none;
    font-size: 12px;
    padding: 4px 12px;
    border-color: ${colors.shades.gamma3};
    color: ${colors.base.beta};

    &.Mui-selected {
      background-color: ${colors.shades.secondary3};
      color: ${colors.base.alpha};
      border-color: ${colors.shades.secondary3};

      &:hover {
        background-color: ${colors.shades.secondary8};
      }
    }
  }
`;

const DayToggleButtonGroup = styled(StyledToggleButtonGroup)`
  .MuiToggleButton-root {
    flex: 1;
    min-width: 36px;
    padding: 6px 0;
  }
`;

export {
  Container,
  Section,
  Label,
  ToggleRow,
  StyledToggleButtonGroup,
  DayToggleButtonGroup,
};
